import { uploadPresignedFile } from "@retro-ia/shared/upload";
import type { UploadPresignedFileResult } from "@retro-ia/shared/upload";
import type { CreateIntentoDto } from "@/hooks/intentos/useIntentos";

export interface UploadFileParams {
  file: File;
  actividadId: number;
}

export interface EvaluateFileParams {
  fileUrl: string;
  fileLimpioUrl: string;
  cerebro: string;
  programa: number;
}

export interface CreateIntentoParams {
  actividadAprendizId: number | undefined;
  archivo: UploadPresignedFileResult;
  retro: string;
  sessionId: string;
  sessionPayload: string;
}

/**
 * Servicio de evaluación que contiene toda la lógica de negocio
 * para el proceso de evaluación de archivos
 */
export class EvaluacionService {
  /**
   * Sube un archivo a Google Cloud Storage
   */
  static async uploadFile({
    file,
    actividadId,
  }: UploadFileParams): Promise<UploadPresignedFileResult> {
    return await uploadPresignedFile({
      file,
      ruta: `${actividadId}/${file.name}`,
      fileName: file.name,
      fileType: file.type,
      isPublic: true,
    });
  }

  /**
   * Prepara el DTO para crear un intento
   */
  static prepareIntentoDto({
    actividadAprendizId,
    archivo,
    retro,
    sessionId,
    sessionPayload,
  }: CreateIntentoParams): CreateIntentoDto {
    return {
      idActividadAprendiz: actividadAprendizId,
      archivo,
      retro,
      sessionId,
      sessionPayload,
    };
  }

  /**
   * Valida si se puede realizar una evaluación
   */
  static canEvaluate(
    archivo: File | null,
    intentosUsados: number,
    limiteIntentos: number,
  ): { valid: boolean; reason?: string } {
    if (!archivo) {
      return { valid: false, reason: "No hay archivo seleccionado" };
    }

    if (intentosUsados >= limiteIntentos) {
      return { valid: false, reason: "Has alcanzado el límite de intentos" };
    }

    return { valid: true };
  }
}
